import laravel_logo from '../assets/laravel.png'
import react_logo from '../assets/react.png'
import angular_logo from '../assets/angular.png'
import jquery_logo from '../assets/jquery.svg'
import uiux_logo from '../assets/uiux.png'
import websocket_logo from '../assets/websocket.png'
import phpunit_logo from '../assets/phpunit.svg'
import nginx_logo from '../assets/nginx.svg'
import docker_logo from '../assets/docker.png'
import apache_log from '../assets/apache.jpg'
import expressjs_logo from '../assets/expressjs.png'

export const TECHONOLOGIES = {
    LARAVEL: 'Laravel',
    REACT: 'ReactJS',
    ANGULAR: 'Angular',
    JQUERY: 'JQuery',
    UIUX: 'UI/UX',
    WEBSOCKET: 'WebSocket',
    PHPUNIT: 'PHPUnit',
    NGINX: 'Nginx',
    DOCKER: 'Docker',
    APACHE: 'Apache',
    REACTNATIVE: 'Raect Native',
    EXPRESSJS: 'ExpressJS',
}


export const technologies = [
  {
    id: 1,
    name: TECHONOLOGIES.LARAVEL,
    logo: laravel_logo
  },
  
  {
    id: 2,
    name: TECHONOLOGIES.REACT,
    logo: react_logo
  },
  
  {
    id: 3,
    name: TECHONOLOGIES.ANGULAR,
    logo: angular_logo
  },
  {
    id: 4,
    name: TECHONOLOGIES.JQUERY,
    logo: jquery_logo
  },
  {
    id: 5,
    name: TECHONOLOGIES.UIUX,
    logo: uiux_logo
  },
  {
    id: 6,
    name: TECHONOLOGIES.WEBSOCKET,
    logo: websocket_logo
  },
  {
    id: 7,
    name: TECHONOLOGIES.PHPUNIT,
    logo: phpunit_logo
  },
  {
    id: 8,
    name: TECHONOLOGIES.NGINX,
    logo: nginx_logo
  },
  {
    id: 9,
    name: TECHONOLOGIES.DOCKER,
    logo: docker_logo
  },
  {
    id: 10,
    name: TECHONOLOGIES.APACHE,
    logo: apache_log
  },
  {
    id: 11,
    name: TECHONOLOGIES.EXPRESSJS,
    logo: expressjs_logo
  },
  {
    id: 11,
    name: TECHONOLOGIES.REACTNATIVE,
    logo: react_logo
  },
];
export const getTechonologies = (...array) =>
    technologies.filter((techonology) =>
        array.includes(techonology.name)
    );